






















import Vue from "vue";

export default Vue.extend({
  name: "Btn",
  props: {
    color: {
      /* main | transparent */
      type: String,
      default: "main",
    },
    round: { type: Boolean, default: false },
    border: { type: Boolean, default: false },
    disabled: Boolean,
    wide: { type: Boolean, default: false },
  },
});
